export const CREATE_MASTER_RAMADAN_DATE = "CREATE_MASTER_RAMADAN_DATE";
export const FETCH_MASTER_RAMADAN_DATES = "FETCH_MASTER_RAMADAN_DATES";
export const FETCH_MASTER_RAMADAN_DATE = "FETCH_MASTER_RAMADAN_DATE";
export const EDIT_MASTER_RAMADAN_DATE = "EDIT_MASTER_RAMADAN_DATE";
export const DELETE_MASTER_RAMADAN_DATE = "DELETE_MASTER_RAMADAN_DATE";
